module.exports = __webpack_public_path__ + "img/lego-1.fc28253c.jpg";